<template>
    <div class="animated fadeIn efficiency">
        <filters :scope="filtersScope">
        </filters>
        <div class="statistic-wrap">
            <div class="card-block"  v-if="loading">
                <div class="row">
                    <div class="col-md-12">
                        <div class="logout-message" style="text-align: center;">{{ $t('message.loading') }}
                            <i aria-hidden="true" class="fa fa-spinner fa-spin"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card statistic-table" v-else>
                <div v-if="allCountry">
                    <div style="margin-bottom: 40px;" v-for="(rowsDate,indexCountry) in rowsAll">
                        <div class="card-header">
                            {{ Helper.findCountryName(indexCountry) }}
                        </div>
                        <table class="table">
                            <thead>
                            <tr>
                                <th>Дата</th>
                                <th :colspan="cell.colspan" v-for="cell in headColumnsAll" v-if="cell[indexCountry]">{{ cell[indexCountry] }}</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, i) in rowsDate">
                                    <td>{{ i }}</td>
                                    <td v-for="col in headColumnsAll" v-if="col[indexCountry]">
                                        <span v-if="row[col[indexCountry]]">{{row[col[indexCountry]]}}%</span>
                                        <span v-else> - </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div v-else>
                    <div class="card-header">
                        {{ $t('pages.approved_during_the_day') }}
                    </div>
                    <div class="card-block card-zz">
                        <table class="table" >
                            <thead>
                            <tr>
                                <th>Дата</th>
                                <th :colspan="col.colspan" v-for="col in headColumns">{{ col.label }}ч.</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(row, i) in rows">
                                <td>{{ i }}</td>
                                <td v-for="col in headColumns" style="position: relative" @mouseover='mouseOver(row[col.label].approved, row[col.label].total, $event)' @mouseleave="mouseleave(row[col.label].approved, row[col.label].total, $event)">
                                    <span
                                            v-if="row[col.label]">
                                    {{ row[col.label].data }}%
                                    </span>
                                     <span class="no-tool" v-else> - </span>
                                    <span  class="tool">
                                        {{ this.approved }}
                                    </span>
                                </td>
                            </tr>
                            </tbody>
                            <tfoot>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Filters from '../../../components/Filters.vue'
import API from '../../../api/API'
import Storage from '../../../api/Storage'
import Helper from '../../../api/Helper'
import TypeColor from '../../../assets/TypeColor'
import { map } from 'lodash'

export default {
  name: 'OperatorSchedule',
  components: {
    Filters
  },
  data () {
    return {
      filtersScope: {
        dateFilter: true,
        offerFilter: true
      },
      loading: false,
      Storage: Storage,
      TypeColor: TypeColor,
      Helper: Helper,
      rows: [],
      rowsAll: [],
      headColumns: [],
      headColumnsAll: [],
      hoursHead: [],
      allCountry: false,
      isShow: false,
      approved: null,
      total: null
    }
  },
  computed: {
    computedHeadColumns () {
      if (!this.columns) {
        return this.headColumns
      } else {
        let headColumns = []
        this.headColumns.map((d) => {
          if (this.columns[d.field]) {
            headColumns.push(d)
          }
        })
        return headColumns
      }
    }
  },
  mounted () {
    this.operators = Storage.operators.slice(0)
    this.calculateRows()
    this.$root.$on('filters_load_new_data', () => {
      this.calculateRows()
    })
  },
  methods: {
    /* tooltip (approved, total, e) {
        /!* style="position: relative" @click='tooltip(row[col.label].approved, row[col.label].total, $event)' *!/
      if (e.target) {
        this.approved = approved
        console.log(this.approved, 'app')
        let dBlock = e.target.querySelector('.tool')
        if (dBlock.style.display === 'block') {
          dBlock.style.display = 'none'
        } else {
          dBlock.style.display = 'block'
          let approvedText = `Подтверждено: ${approved}`
          let totalText = `Всего: ${total}`
          dBlock.innerText = `${approvedText} \r\n ${totalText}`
        }
      }
    }, */
    mouseOver (approved, total, e) {
      if (e.target && !e.target.classList.contains('no-tool')) {
        let dBlock = e.target.querySelector('.tool')
        dBlock.style.display = 'block'
        let approvedText = `Подтверждено: ${approved}`
        let totalText = `Всего: ${total}`
        dBlock.innerText = `${approvedText} \r\n ${totalText}`
      }
    },
    mouseleave (approved, total, e) {
      if (e.target) {
        let dBlock = e.target.querySelector('.tool')
        dBlock.style.display = 'none'
      }
    },
    calculateRows () {
      this.$root.$emit('data_loading')
      this.loading = true
      this.rows = []
      this.headColumns = []
      this.rowsAll = []
      this.headColumnsAll = []
      API.getOperatorApprovedDuringDay()
        .then(res => {
          let hours = []
          for (let i = 1; i <= 24; i++) {
            hours.push({
              hour: i
            })
          }
          map(hours, byHour => {
            let header = {}
            let storageCountry = {}
            let storageHoursCountry = {}
            let storageHours = {
              label: null
            }
            map(res.body, (d, i) => {
              if (Storage.selectedCountry.id === -1) {
                this.allCountry = true
                if (byHour.hour === d.created_time) {
                  storageHours = {
                    label: d.created_time
                  }
                  if (!storageHoursCountry[d.country_id]) {
                    storageHoursCountry[d.country_id] = {}
                  }
                  storageHoursCountry[d.country_id] = d.created_time
                }
                if (!storageCountry[d.country_id]) {
                  storageCountry[d.country_id] = {}
                }
                if (!storageCountry[d.country_id][d.date]) {
                  storageCountry[d.country_id][d.date] = {}
                }
                storageCountry[d.country_id][d.date][d.created_time] = ((parseInt(d.approved) / parseInt(d.total)) * 100).toFixed(2)
              } else {
                this.allCountry = false
                if (!header[d.date]) {
                  header[d.date] = {}
                }
                if (byHour.hour === d.created_time) {
                  storageHours = {
                    label: d.created_time
                  }
                }
                header[d.date][d.created_time] = {}
                header[d.date][d.created_time] = {
                  data: ((parseInt(d.approved) / parseInt(d.total)) * 100).toFixed(2),
                  approved: d.approved,
                  total: d.total
                }
              }
            })
            this.rowsAll = storageCountry
            this.headColumnsAll.push(storageHoursCountry)
            this.rows = header
            this.headColumns.push(storageHours)
            this.headColumns = this.headColumns.filter(hour => hour.label)
          })
          this.loading = false
          this.$root.$emit('data_loaded')
        })
        .catch((response) => {
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: response.body.message ? response.body.message : response.body,
            animationType: 'velocity'
          })
        })
    }
  }
}
</script>

<style scoped>
    .tool {
        position: absolute;
        display: none;
        top: -65px;
        right: -25px;
        width: 165px;
        border: 1px solid #a5aeb2;
        background: #fff;
        padding: 10px 0;
        z-index: 999;
        border-radius: 5px;
    }
</style>



// WEBPACK FOOTER //
// OperatorSchedule.vue?7eb2be92